import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5408200a&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/shared/Header/HeaderStylePublic.css?vue&type=style&index=0&id=5408200a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408200a",
  null
  
)

export default component.exports